import React, { useEffect, useState } from 'react';
interface StickyButtonProps {
  targetRef: React.RefObject<HTMLElement>;
  onClick: () => void;
}
export const StickyButton: React.FC<StickyButtonProps> = ({
  targetRef,
  onClick
}) => {
  const [tomorrowDate, setTomorrowDate] = useState('');
  useEffect(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const day = tomorrow.getDate();
    const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    const month = months[tomorrow.getMonth()];
    setTomorrowDate(`${day} ${month}`);
  }, []);
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t-2 border-gray-200 shadow-lg" data-id="element-287">
      <div className="max-w-3xl mx-auto" data-id="element-288">
        <p className="text-center text-sm text-gray-700 mb-2" data-id="element-289">
          Morgen {tomorrowDate} • 10:00, 13:00 of 20:00
        </p>
        <a href="https://stresslessdogs.nl/mcc-gpm" className="block w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-4 rounded-lg transition duration-200 text-center" target="_blank" rel="noopener noreferrer" data-id="element-290">
          GRATIS WEBINAR: Communiceren Met Je Hond
        </a>
      </div>
    </div>;
};